import React, {Component} from 'react';
import {BrowserRouter as Router, Route} from 'react-router-dom';
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import TimeTrackingWeeklyOverview from "./views/TimeTrackingWeeklyOverview";
import ProjectsOverview from "./views/ProjectsOverview";

class App extends Component {
    render() {
        return (
            <Router>
                <div>
                    <Route exact path="/" component={TimeTrackingWeeklyOverview}/>
                    <Route path="/projects" component={ProjectsOverview}/>
                </div>
            </Router>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js